import { render } from "./ChildProducts.vue?vue&type=template&id=4861b26c"
import script from "./ChildProducts.vue?vue&type=script&lang=js"
export * from "./ChildProducts.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__